import { InjectionToken } from '@angular/core';

import type { ISocialItem, ISocialLinkService, TSocialKey } from './social-link.type';

export const SUPPORT_EMAIL = 'support@chaichat.ai';

export const SOCIALS_CONFIG: Record<TSocialKey, ISocialItem> = {
  telegram: {
    key: 'telegram',
    title: 'Telegram',
    link: 'https://www.t.me/caichatai',
    icon: 'ph ph-telegram-logo',
  },

  discord: {
    key: 'discord',
    title: 'Discord',
    link: 'https://www.discord.gg/YjBX4v4shh',
    icon: 'ph ph-discord-logo',
  },

  instagram: {
    key: 'instagram',
    title: 'Instagram',
    link: 'https://www.instagram.com/caichat.ai',
    icon: 'ph ph-instagram-logo',
  },

  tiktok: {
    key: 'tiktok',
    title: 'TikTok',
    link: 'https://www.tiktok.com/@caichat',
    icon: 'ph ph-tiktok-logo',
  },

  twitter: {
    key: 'twitter',
    title: 'Twitter',
    link: 'https://www.x.com/Caichatai',
    icon: 'ph ph-x-logo',
  },

  email: {
    key: 'email',
    title: 'Email',
    link: 'mailto:support@caichat.ai',
  },
};

export const SOCIAL_LINKS_SERVICE = new InjectionToken<ISocialLinkService>('SOCIAL_LINK');
